import React from "react";
import { Link } from "react-router-dom";
import Countdown from "./Countdown"; // adjust path if needed

const Banner = () => {
  return (
    <section className="banner position-relative pb-50">
      <div className="overlay"></div>
      <div className="container">
        <div className="inner-banner position-relative text-white">
          <div className="row align-items-center">
            {/* Left Side: Countdown */}
            <div className="col-lg-6 order-2 order-lg-1">
              <div className="banner-left text-center pb-lg-5 p-md-0">
                <div className="countdown">
                  <div
                    id="countdown"
                    className="countdown-inner d-flex w-100 bg-white p-2 rounded-3 justify-content-center box-shadow position-relative z-2"
                  >
                    <Countdown />
                  </div>
                </div>
              </div>
            </div>

            {/* Right Side: Event Info */}
            <div className="col-lg-6 order-1 order-lg-2">
              <div className="banner-right ms-2 text-center text-lg-start pb-8">
                {/* Title */}
                <div className="banner-title pb-3">
                  <h4 className="text-white pb-2">
                    UPCOMING <span className="pink">ENERGY EVENT</span> 2026
                  </h4>
                  <h1 className="text-white fw-bold">
                    FutureOil <span className="pink">2026</span>
                  </h1>
                  <h3 className="text-white fw-semibold mt-2">
                    AI, Data & the Net-Zero Energy Shift
                  </h3>
                </div>

                {/* Event Date & Location */}
                <div className="banner-event-info pb-3">
                  <ul className="m-0 ps-0 d-sm-flex flex-wrap justify-content-center justify-content-lg-start list-unstyled">
                    <li className="pe-sm-3 me-sm-3 mb-2 mb-sm-0 border-end border-light">
                      <i className="fa fa-calendar-o pe-1"></i> 21-22 April, 2026
                    </li>
                    <li className="ps-sm-3">
                      <i className="fa fa-map-marker pe-1"></i> 100% Virtual on Hubilo
                    </li>
                  </ul>
                </div>

                {/* Description */}
                <div className="event-description">
                  <p className="pb-4 m-0">
                    Join global leaders and innovators as we explore how AI, big
                    data, and digital transformation are shaping the energy
                    sector towards a net-zero future.
                  </p>

                  {/* Buttons */}
                  <div className="banner-button">
                    <div className="row g-2">
                      <div className="col-md-6">
                        <Link to="/Booknow" className="btn me-md-2 w-100">
                          PURCHASE TICKET
                        </Link>
                      </div>
                      <div className="col-md-6">
                        <Link to="/contact" className="btn btn2 w-100">
                          Download Brochure
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Subtle gradient fade at bottom */}
      <div className="banner-fade"></div>

      {/* Styling */}
      <style>{`
        .banner-title h1 {
          font-size: 2.5rem;
          line-height: 1.2;
        }
        .banner-title h3 {
          font-size: 1.3rem;
          line-height: 1.4;
        }
        @media (max-width: 767px) {
          .banner-title h1 {
            font-size: 1.8rem;
          }
          .banner-title h3 {
            font-size: 1.1rem;
          }
          .banner-event-info ul {
            flex-direction: column !important;
            text-align: center;
          }
          .banner-event-info li {
            border: none !important;
            padding: 5px 0;
          }
        }
        /* Subtle bottom fade */
        .banner-fade {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 50px; /* very small */
          background: linear-gradient(to bottom, transparent, #fff);
          z-index: 2;
        }
      `}</style>
    </section>
  );
};

export default Banner;
